import { styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";



export const ListItemTitle = styled(Typography)({
    width: 86
})